<template>
<div>
    <div>
        <busqueda @search="search" :month="true" :routeData="routeData" :fecha="fecha"/>
    </div>
    <div class="row mt-3">
        <div class="col-lg-12 col-md-12 col-12">
            <div class="ibox ">
                <div class="ibox-title">
                    <div class="ibox-tools">
                        <a class="collapse-link">
                            <i class="fa fa-chevron-up"></i>
                        </a>
                    </div>
                </div>
                <div class="ibox-content">
                    <table class="table table-striped table-bordered w-100 tabla-default">
                        <thead>
                            <tr>
                                <th><i class="fal fa-address-card"></i> Nombre</th>
                                <th><i class="fal fa-address-card"></i> Descripcion</th>
                                <th><i class="fal fa-address-card"></i> Cantidad</th>
                                <th><i class="fal fa-address-card"></i> Tipo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in data" :key="index">
                                <td>{{item.nombre}}</td>
                                <td>{{item.descripcion}}</td>
                                <td>{{item.cantidad}}</td>
                                <td>{{item.tipo}}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>

            </div>
        </div>
    </div>
</div>
</template>

<script>
import Busqueda from '../../Dashboard/Busqueda.vue'
export default {
    props: ['resumen', "routeData","fecha"],
    components: {
        Busqueda
    },
    data() {
        return {
            data: []
        }
    },
    mounted() {
            // console.log(this.resumen);
        let x = JSON.parse(this.resumen)
        if (this.resumen) {
            // console.log(x);
            let data = {};
            Object.entries(x).forEach(([key, value]) => {
                let res = this.buscarKey(key)
                // console.log(key);
                // console.log(value);
                if (key != "id" && key != "fecha" && key != "created_at" && key != "updated_at") {
                    data = {
                        nombre: res.titulo,
                        descripcion: res.descripcion,
                        cantidad: value,
                        tipo: res.tipo
                    }

                    this.data.push(data);
                }
            });
        }
    },
    methods: {

        buscarKey(key) {
            let titulo = "";
            let tipo = "";
            let descripcion = "";
            switch (key) {
                case 'agendadas_inbound':
                    titulo = "Citas Solo Agendadas";
                    descripcion= "Toda cita que agendamos por nuestros canales";
                    tipo = "Inbound";
                    break;
                case 'agendadas_totales_inbound':
                    titulo = "Citas Agendadas Totales";
                    descripcion= "TODA CITA QUE AGENDAMOS NOSOTROS VALIDA CON ALGUN CANAL PROCESADO + CITA EN ESTADO PAGA";
                    tipo = "Inbound";
                    break;
                case 'citas_validas_outbound':
                    titulo = "Citas Validas";
                    descripcion="TOTAL - [ANULADAS+ BLOQUEADAS + NO PROCESADAS]";
                    tipo = "Inbound";
                    break;
                case 'gestionadas_inbound':
                    titulo = "Citas Gestionadas";
                    descripcion= "AGENDADAS + ANULADAS + CONFIRMADAS";
                    tipo = "Inbound";
                    break;
                case 'gestionadas_outbound':
                    titulo = "Citas Gestionadas";
                    descripcion="TODA CITA VALIDA CON ALGUN CANAL PROCESADO + CITA EN ESTADO PAGA";
                    tipo = "Outbound";
                    break;
                case 'links_cortos':
                    titulo = "Links Cortos";
                    descripcion = "Total de link cortos";
                    tipo = "Outbound";
                    break;
                case 'no_gestionadas_outbound':
                    titulo = "No Gestionadas";
                    descripcion = "TODA CITA SIN CANALES PROCESADOS";
                    tipo = "Outbound";
                    break;
                case 'total_wsp':
                    titulo = "Whatsapp Enviados";
                    descripcion = "Total de Whatsapp Enviados";
                    tipo = "Salida";
                    break;
                case 'total_sms':
                    titulo = "SMS Enviados";
                    descripcion = "Total de SMS Enviados";
                    tipo = "Salida";
                    break;

                case 'total_email':
                    titulo = "Correos Enviados";
                    descripcion = "Total de Correos Enviados";
                    tipo = "Salida";
                    break;
                default:
                    titulo = "Error";
                    break;
            }

            return { titulo: titulo, tipo: tipo,descripcion: descripcion };
        }
    },
}
</script>
